import { Modal } from '@ax/ui';
import { ModalDialog } from '@ax/ui';
import { ModalHeader } from '@ax/ui';
import { ModalBody } from '@ax/ui';
import ProviderNoteTemplates from '@/components/ProviderNoteTemplates/ProviderNoteTemplates.tsx';
import style from './NoteTemplatesModal.module.scss';
import { Button } from '@ax/ui';
import { useAppSelector } from '@ax/redux-store';
import { selectNoteTemplateIdSelected } from '@ax/redux-store';
import { useState } from 'react';
import { selectProviderNoteTemplates } from '@ax/redux-store';
import { useEffect } from 'react';

interface NoteTemplatesModalProps {
  modalOpen?: boolean;
  modalClose?: () => void;
  modalContinue?: (newValue?: { templateId: string; templateName: string }) => void;
  modalData?: {
    noteId: string;
    providerNoteTemplates: { templateId: string; templateName: string }[];
  };
}

const NoteTemplatesModal: React.FC<NoteTemplatesModalProps> = ({
  modalOpen = false,
  modalClose,
  modalContinue,
}) => {
  const selectedProviderNoteTemplateId = useAppSelector(selectNoteTemplateIdSelected);
  const providerNoteTemplates = useAppSelector(selectProviderNoteTemplates);

  const [selectedTemplate, setSelectedTemplate] = useState<{
    templateId: string;
    templateName: string;
  }>();

  useEffect(() => {
    setSelectedTemplate(
      providerNoteTemplates?.find(
        (template: { templateId: string; templateName: string }) =>
          template?.templateId === selectedProviderNoteTemplateId,
      ),
    );
  }, [providerNoteTemplates, selectedProviderNoteTemplateId]);

  const handleModalClose = () => modalClose?.();
  const handleModalContinue = (selectedTemplate?: { templateId: string; templateName: string }) =>
    modalContinue?.(selectedTemplate);

  const onNoteTemplateChange = (newValue: { value: string; label: string }) => {
    setSelectedTemplate({ templateId: newValue.value.toString(), templateName: newValue.label });
  };

  return (
    <Modal onShow={modalOpen}>
      <ModalDialog>
        <ModalHeader onHide={handleModalClose}>
          <div className={style.note__template__title}>Choose a template</div>
        </ModalHeader>
        <ModalBody>
          <div className={style.note__template__dropdown}>
            <ProviderNoteTemplates
              templates={providerNoteTemplates}
              selectedTemplate={
                selectedTemplate
                  ? selectedTemplate
                  : providerNoteTemplates
                  ? providerNoteTemplates[0]
                  : null
              }
              onValueChanged={(newValue: { value: string; label: string }) =>
                onNoteTemplateChange(newValue)
              }
            />
          </div>
          <div className={style.note__template__buttons_container}>
            <Button
              variant={'outline'}
              onClick={handleModalClose}
              label={'Cancel'}
            />
            <Button
              variant={'primary'}
              onClick={() => handleModalContinue(selectedTemplate)}
              label={'Continue'}
            />
          </div>
        </ModalBody>
      </ModalDialog>
    </Modal>
  );
};

export default NoteTemplatesModal;
